import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.6357 11.25L13.3857 6L14.7998 4.58594L21.7568 11.543C21.9444 11.7305 22.0498 11.9848 22.0498 12.25C22.0498 12.5152 21.9444 12.7695 21.7568 12.957L14.7998 19.9141L13.3857 18.5L18.6357 13.25L2 13.25V11.25L18.6357 11.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }